<template>
  <Counter :date="dateEnd" />
</template>

<script>
import Counter from './Counter';

const finalDate = new Date().getTime() + 1000 * 60 * 60 * 24 * 2; // 2 days

export default {
  components: {
    Counter,
  },
  data() {
    return {
      dateEnd: new Date(finalDate),
      // dateEnd: '07/17/2024 23:59:59',
    };
  },
  mounted() {
    const qs = new URLSearchParams(window.location.search);
    const date = qs.get('dateEnd');
    console.log(date);
    if (date) {
      this.dateEnd = date;
    }
  }
};
</script>
